import React, { ReactElement } from 'react';
import ListItem from './list-item';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { MapState } from '../../map/reducer';
import { SelectedKrets } from '../../../../catalog/krets-actions';
import Sorting from './sorting';
import { portAndWaterwayObjectSorter } from '../../../../utils';
import { UseParams } from '../../../../types';

const DEFAULT_TITLE = 'Hamn & Farleds-objekt';
interface InlinePortAndWaterwayObjectListProps {
  title?: string;
}

export default function InlinePortAndWaterwayObjectList(props: InlinePortAndWaterwayObjectListProps): ReactElement {
  const { items, filterText, selectedKrets, sortGeo } = useSelector((state: { map: MapState; selectedKrets: SelectedKrets[] }) => ({
    items: [].concat(state.map.objects),
    filterText: state.map.filterText,
    selectedKrets: state.selectedKrets,
    sortGeo: state.map.sortGeo,
  }));
  items.sort(portAndWaterwayObjectSorter(sortGeo));
  const { slug }: UseParams = useParams();
  let filteredItems = items.filter((o) => !slug || slug === 'alla' || slug === o.type);
  if (filterText) {
    const m = new RegExp(filterText, 'gi');
    filteredItems = filteredItems.filter((item) => m.test(item.name + ' ' + item.description));
  }
  if (selectedKrets && selectedKrets.length > 0) {
    const selected = selectedKrets.map((item) => item.value);
    filteredItems = filteredItems.filter((item) => selected.includes(item.organizationId));
  }

  const title = props.title || !slug || slug === 'alla' ? props.title || DEFAULT_TITLE : filteredItems[0]?.typeName || DEFAULT_TITLE;
  return (
    <div className="region region-content">
      <div id="block-sxk-theme-page-title" className="contextual-region block block-core block-page-title-block">
        <div className="block-content">
          <div className="page-title-box">
            <div
              className="page-title-box-inner content-bg"
              style={{
                display: 'flex',
                flexFlow: 'row',
                justifyContent: 'space-between',
              }}
            >
              <h1>{title}</h1>
              <Sorting />
            </div>
          </div>
        </div>
      </div>
      <div id="block-sxk-theme-content" className="block block-system block-system-main-block">
        <div className="block-content">
          <div className="views-element-container contextual-region grouped-items">
            <div className="contextual-region view view-map-images view-id-map_images view-display-id-all">
              <div className="view-content">
                <div className="clearfix grouped-items">
                  {filteredItems.map((item) => (
                    <ListItem key={item.id} {...item} />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
